import React from 'react';
import PropTypes from 'prop-types';
import intl from "react-intl-universal";
import common from '../../../common/common';
import Button from "../Button";
import styles from './index.module.scss';

class Modal extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        visible: false,
        width: common.isPhone() ? 30 : 320,
        wrapClassName: '',
        maskStyle: {},
        showPendant: false,
        closable: false,
        title: '',
        children: '',
        footer: undefined,
        okText: '',
        okType: 'primary',
        okButtonProps: {},
        onOk: null,
        cancelText: '',
        cancelType: 'default',
        cancelButtonProps: {},
        onCancel: null,
        afterClose: null
    };

    static propTypes = {
        visible: PropTypes.bool, // 弹窗是否展示
        // 弹窗宽度
        width: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        wrapClassName: PropTypes.string, // 弹窗className
        maskStyle: PropTypes.object, // 遮罩样式
        showPendant: PropTypes.bool, // 弹窗是否展示顶部挂件
        closable: PropTypes.bool, // 是否展示关闭按钮
        // 弹窗标题
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        // 弹窗内容
        children: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        // 底部内容，当不需要默认底部按钮时，可以设为 footer={null}
        footer: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        okText: PropTypes.string, // ok 按钮文案
        okType: PropTypes.string, // ok 按钮type值
        okButtonProps: PropTypes.object, // ok 按钮 props
        onOk: PropTypes.func, // 点击确定按钮后的回调
        cancelText: PropTypes.string, // cancel 按钮文案
        cancelType: PropTypes.string, // cancel 按钮type值
        cancelButtonProps: PropTypes.object, // cancel 按钮 props
        onCancel: PropTypes.func, // 点击取消按钮/关闭按钮后的回调
        afterClose: PropTypes.func, // Modal完全关闭后的回调
    };

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState) {
        // Modal完全关闭后的回调
        if (!this.props.visible && prevProps.visible) {
            typeof this.props.afterClose === 'function' && this.props.afterClose();
        }
    }

    onOk = (e) => {
        typeof this.props.onOk === 'function' && this.props.onOk(e);
    };

    onCancel = (e) => {
        typeof this.props.onCancel === 'function' && this.props.onCancel(e);
    };

    renderFooter = () => {
        const { okText, okType, okButtonProps, cancelText, cancelType, cancelButtonProps } = this.props;
        const showCancel = 'showCancel' in this.props ? this.props.showCancel : true; // 是否展示取消按钮（默认展示）
        return (
            <ul className="modal-btnList">
                {
                    showCancel && (
                        <li>
                            <Button
                                type={cancelType || 'default'}
                                onClick={this.onCancel}
                                {...cancelButtonProps}
                            >
                                {cancelText || intl.get('CANCEL_TEXT')}
                            </Button>
                        </li>
                    )
                }
                <li>
                    <Button
                        onClick={this.onOk}
                        type={okType || 'primary'}
                        {...okButtonProps}
                    >
                        {okText || intl.get('OK_TEXT')}
                    </Button>
                </li>
            </ul>
        );
    };


    render() {
        const {
            visible,
            width,
            wrapClassName,
            maskStyle,
            showPendant,
            closable,
            title,
            children,
            footer
        } = this.props;

        const dialogWidth = typeof width === 'string' ? parseFloat(width) : width;

        const finalFooter = footer === undefined ? this.renderFooter() : footer;

        return (
            <div className={`common-modal-container ${wrapClassName} ${visible ? '' : 'hide'}`} style={maskStyle}>
                <div className="common-modal-wrap" style={{width: `${dialogWidth}${common.isPhone() ? 'rem' : 'px'}`}}>
                    {
                        title && <div className="common-modal-title">{title}</div>
                    }
                    <div className="common-modal-content dark-scroll-bar">
                        <div className="common-modal-content-inner">
                            {
                                children
                            }
                        </div>
                    </div>
                    {
                        finalFooter &&
                        <div className="common-modal-footer">
                            {
                                finalFooter
                            }
                        </div>
                    }

                    {
                        closable && <div className="icon-close" onClick={this.onCancel}/>
                    }
                    {
                        showPendant && <div className="common-modal-pendant"/>
                    }

                </div>
            </div>
        )
    }
}
export default Modal;

export const destroyFns = [];